module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921064151_T.3f8bd668.jpg";